// The tags box on a page the admin edits in place: tags typed as one
// comma-separated line.
import { useState } from "react";

const splitTags = (text: string): string[] =>
  text
    .split(",")
    .map((t) => t.trim())
    .filter(Boolean);

/**
 * The box keeps the line as typed and hands the page the list. Showing the
 * list back instead — `tags.join(", ")` — turned "prayer," into ["prayer"],
 * and so back into "prayer", on the very keystroke that typed the comma: a
 * second tag could never be started. The box is mounted when editing begins,
 * so it starts from the tags the page has then.
 */
export function TagsInput({ tags, onChange }: { tags: readonly string[]; onChange: (tags: string[]) => void }) {
  const [text, setText] = useState(() => tags.join(", "));
  return (
    <input
      value={text}
      onChange={(e) => {
        setText(e.target.value);
        onChange(splitTags(e.target.value));
      }}
      placeholder="tags, comma, separated"
      aria-label="Tags"
      className="min-w-[240px] flex-1 rounded border border-rule bg-paper px-2 py-1 font-sans text-[12px] text-ink focus:border-accent focus-visible:outline-none"
    />
  );
}
